exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bread {\n  /* background-color: black; */\n}\n\n.bread ol {\n  background-color: white;\n  margin-bottom: 0px;\n}\n\n.bread ol li {\n  max-width: 300px !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n", ""]);

